const Config = {
  storage: typeof window !== 'undefined' ? window.sessionStorage : undefined,
  defaultPriority: 4,
  defaultTTL: 24 * 60 * 60 * 1000,
  capacityInBytes: 5 * 1024 * 1024,
  itemMaxSize: 200 * 1024,
  warningThreshold: 0.8,
};

export { Config };